<script>

// 2. Import the `generateChart()` method to create the vue component.
import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: ['labels', 'data', 'title'],
  mounted () {
    var self = this
    this.renderChart({
      labels: self.labels,
      datasets: [{
        label: self.title,
        backgroundColor: 'transparent',
        borderColor: 'rgba(255,255,255,.3)',
        data: self.data
      }]
    }, {
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      scales: {
        xAxes: [{
          gridLines: {
            color: 'transparent',
            zeroLineColor: 'transparent'
          },
          ticks: {
            fontSize: 2,
            fontColor: 'transparent'
          }
        }],
        yAxes: [{
          display: false,
          ticks: {
            display: false,
            min: Math.min.apply(Math, self.data) - 5,
            max: Math.max.apply(Math, self.data) + 5
          }
        }]
      },
      elements: {
        line: {
          borderWidth: 1
        },
        point: {
          radius: 4,
          hitRadius: 10,
          hoverRadius: 4
        }
      },
      responsive: true
    })
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ui/ChartLine.vue